"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncLocalStorageRecords = exports.ContextUtilsKeys = void 0;
const observability_types_1 = require("@deliverr/observability-types");
const ContextUtils_1 = require("./ContextUtils");
var ContextUtilsKeys;
(function (ContextUtilsKeys) {
    ContextUtilsKeys["DIRECT_CALLER"] = "DIRECT_CALLER";
    ContextUtilsKeys["OUTGOING_DIRECT_CALLER"] = "OUTGOING_DIRECT_CALLER";
    ContextUtilsKeys["X_REQUEST_CALLER"] = "X-Request-Caller";
    ContextUtilsKeys["X_REQUEST_ID"] = "X-Request-Id";
    ContextUtilsKeys["X_TRACE_ID"] = "X-System-Trace-Ids";
    ContextUtilsKeys["X_REQUEST_NAME"] = "X-Request-Name";
})(ContextUtilsKeys = exports.ContextUtilsKeys || (exports.ContextUtilsKeys = {}));
class AsyncLocalStorageRecords {
    get requestCaller() {
        return ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.X_REQUEST_CALLER);
    }
    set requestCaller(caller) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.X_REQUEST_CALLER, caller);
    }
    get directCaller() {
        return ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.DIRECT_CALLER) || observability_types_1.DirectCaller.createNullObject();
    }
    set directCaller(caller) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.DIRECT_CALLER, caller);
    }
    get outgoingDirectCaller() {
        return (ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.OUTGOING_DIRECT_CALLER) || observability_types_1.DirectCaller.createNullObject());
    }
    set outgoingDirectCaller(caller) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.OUTGOING_DIRECT_CALLER, caller);
    }
    get requestId() {
        return ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.X_REQUEST_ID);
    }
    set requestId(requestId) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.X_REQUEST_ID, requestId);
    }
    get traceId() {
        return ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.X_TRACE_ID);
    }
    set traceId(traceId) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.X_TRACE_ID, traceId);
    }
    get requestName() {
        return ContextUtils_1.contextUtils.getContext(ContextUtilsKeys.X_REQUEST_NAME);
    }
    set requestName(caller) {
        ContextUtils_1.contextUtils.setContext(ContextUtilsKeys.X_REQUEST_NAME, caller);
    }
}
exports.asyncLocalStorageRecords = new AsyncLocalStorageRecords();
//# sourceMappingURL=AsyncLocalStorageRecords.js.map